export enum ProjectStatus {
  Active = 1,
  Closed = 2,
}
